//import { reset } from 'redux-form'
import api from '../api'
import {loadInitialData} from './initialData'

function setCurrentUser(dispatch, response) {	//save sessions in local storage for api requests
	localStorage.setItem('ls.session', JSON.stringify(response))
	dispatch({ type: 'AUTHENTICATION_SUCCESS', response })
	return null
} 

 
export function login(data) {
	return (dispatch) => api.post('/sessions', data)
		.then((response) => {
			dispatch({type:'LOGIN_SUCESS',response})
			setCurrentUser(dispatch, response)
			dispatch(loadInitialData(response.user))				
			return response
		})
}

export function googleLogin(data) {
	return (dispatch) => api.post('/sessions/google-signin', data)
		.then((response) => {
			dispatch({type:'LOGIN_SUCESS',response})
			setCurrentUser(dispatch, response)
			dispatch(loadInitialData(response.user))
			return response
		})
		.catch(() => {

		})

}


export function signup(data) {
	return (dispatch) => api.post('/users', data)
		.then((response) => {
			return response
		})
}

export function logout() {
	return (dispatch) => api.delete('/sessions')
		.then((response) => {
			localStorage.removeItem('ls.session')
			localStorage.removeItem('plickers-tab-sync')
			localStorage.removeItem('service.product')
			dispatch({ type: 'LOGOUT' })
			window.location = '/login'
			window.analytics.reset()
		})
		.catch(() => {

		})	

}

export function authenticate(data) {
	const url = `/sessions?token=${data}`
	localStorage.removeItem('plickers-tab-sync')
	return (dispatch) => {
		dispatch({ type: 'AUTHENTICATION_REQUEST' })
		return api.fetch(url)
			.then((response) => {
				setCurrentUser(dispatch, response)
				// window.analytics.identify(response.id)
			})
			.catch(() => {
				localStorage.removeItem('ls.session')
				window.location = '/login'
				//window.location='http://static-papa-lima.s3-website-us-west-2.amazonaws.com/'
			})
	}
}


export const unauthenticate = () => ({ type: 'AUTHENTICATION_FAILURE' })





// WEBPACK FOOTER //
// ./src/actions/session.js